// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const loginInPasswordMax = 256;

export const LoginIn = zod.object({
  "email": zod.email(),
  "password": zod.string().min(1).max(loginInPasswordMax)
});

export type LoginIn = zod.input<typeof LoginIn>;
export type LoginInOutput = zod.output<typeof LoginIn>;
